$(function(){ 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: 992,
    collapserTitle: '',
    animSpeed: 1,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });

  $('a[href*="#"]:not([href="#"])').on('click', function() {
    var target = $(this.hash);
    $('html,body').stop().animate({
      scrollTop: target.offset().top - 150
    }, 'linear');
    $('.collapse-button').removeClass('expanded').children('i').removeClass('fa-times').addClass('fa-bars');
    $('.slimmenu.collapsed').hide();   
  });    
  if (location.hash){
    var id = $(location.hash);
  }
  $(window).load(function() {
    if (location.hash){
      $('html,body').animate({scrollTop: id.offset().top -150}, 'linear');
    }
  });

  $('li a').each(function() {
    var dom = "vgreed.com";
    var url = $(this).attr('href');
    if(url.includes(dom) && url.includes('#')) {
      var pieces = $(this).attr('href').split('/');
      if(pieces.length > 3){
        var newurl = pieces.slice(3).join('/');
        $(this).attr('href', '/' + newurl);
      } else {
        var hash = $(this).attr('href').split('#');
        $(this).attr('href', '#' + hash[1]);
      }
    }
  });

  $(".slimmenu ul > li.has-submenu").on('mouseenter mouseleave', function (e) {
    var elm = $('>ul', this);
    var off = elm.offset();
    var l = off.left;
    var w = elm.width();
    var docW = $("body").width();

    var isEntirelyVisible = (l + w <= docW);

    if (!isEntirelyVisible) {
        $(this).children('ul').addClass('edge');
    } else {
        $(this).children('ul').removeClass('edge');
    }
  });

  if(!$('.personabar-visible').length){
    $(window).on('scroll', function(){
      var scroll = $('header').offset().top;
      if(scroll > '80'){
        $('header').addClass('scrolled');
      } else if(scroll == '0') {
        $('header').removeClass('scrolled');
      }
    });
  }
});
